import { PublicKey } from "@solana/web3.js";
export const PROGRAM_ID = new PublicKey("stcfiqW3fwD9QCd8Bqr1NBLrs7dftZHBQe7RiMMA4aM");
//# sourceMappingURL=constants.js.map